import { Stack } from '@mui/material';

import {
  displaySnackbarError,
  displaySnackbarSuccess,
  displaySnackbarWarning,
} from '@/domain/snackbar/actions/show-snackbar.action';
import { FSPrimaryButton } from '@/ui/components/button/FSPrimaryButton';
import { buildSnackbarButton } from '@/ui/components/snackbar/SnackbarButton';
import { useAppDispatch } from '@/ui/hook/store';

export function SnackbarDemo() {
  const dispatch = useAppDispatch();
  return (
    <Stack sx={{ alignItems: 'start', gap: 2 }}>
      <FSPrimaryButton
        onClick={() => {
          dispatch(
            displaySnackbarSuccess({
              message: 'Success message',
            }),
          );
        }}
      >
        Show success snackbar
      </FSPrimaryButton>
      <FSPrimaryButton
        color="warning"
        onClick={() => {
          dispatch(
            displaySnackbarWarning({
              message: 'Warning message',
            }),
          );
        }}
      >
        Show warning snackbar
      </FSPrimaryButton>
      <FSPrimaryButton
        color="error"
        onClick={() => {
          dispatch(
            displaySnackbarError({
              message: 'Error message',
            }),
          );
        }}
      >
        Show error snackbar
      </FSPrimaryButton>
      <FSPrimaryButton
        color="info"
        onClick={() => {
          dispatch(
            displaySnackbarSuccess({
              message: 'Error message',
              extraProps: {
                action: (
                  <FSPrimaryButton
                    color="inherit"
                    onClick={() => {
                      alert('action button clicked');
                    }}
                  >
                    Action button archi big make snack bar bigger
                  </FSPrimaryButton>
                ),
              },
            }),
          );
        }}
      >
        Show snackbar with ACTION
      </FSPrimaryButton>
      <FSPrimaryButton
        color="info"
        onClick={() => {
          dispatch(
            displaySnackbarSuccess({
              message: 'Error message',
              extraProps: {
                action: buildSnackbarButton(
                  'Action button archi big make snack bar bigger',
                  () => {
                    alert('action button clicked');
                  },
                ),
              },
            }),
          );
        }}
      >
        Show snackbar with ACTION (buildSnackbarButton)
      </FSPrimaryButton>
      <FSPrimaryButton
        onClick={() => {
          dispatch(
            displaySnackbarError({
              message: (
                <>
                  Error on import:
                  <br />
                  {String(new TypeError('blablablablal'))}
                </>
              ),
            }),
          );
        }}
      >
        Show erro snack with details on second line
      </FSPrimaryButton>
    </Stack>
  );
}
